import moment from 'moment-timezone';
import UserCountry from 'js/services/UserCountry';

export function localTime(dateTime, format = null, timezone = moment.tz.guess()) {
  return dateTime
    ? moment
        .utc(dateTime)
        .tz(timezone)
        .format(format ? format : `MMM D YYYY h:mma${timezone !== 'utc' ? ' z' : ''}`)
    : '-';
}


export function minutesToHours(value) {
  if (!value) {
    return '0h 0m';
  }

  if (value < 60) {
    return `${value}m`;
  }

  const hours = Math.floor(value / 60);
  const minutes = value % 60;
  return `${hours}h ${minutes}m`;
}

export function twoDecimals(num) {
  return parseFloat(Math.round(num * 100) / 100).toFixed(2);
}

export function formatMoney(amount, decimalCount, decimal, thousands) {
  var decimalCount = isNaN((decimalCount = Math.abs(decimalCount))) ? 2 : decimalCount,
    decimal = decimal == undefined ? '.' : decimal,
    thousands = thousands == undefined ? ',' : thousands,
    negativeSign = amount < 0 ? '-' : '',
    i = String(parseInt((amount = Math.abs(Number(amount) || 0).toFixed(2)))),
    j = (j = i.length) > 3 ? j % 3 : 0;

  const money =
    negativeSign +
    (j ? i.substr(0, j) + thousands : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
    (decimal +
      Math.abs(amount - i)
        .toFixed(2)
        .slice(2));

  if (money.endsWith('.00') && !decimalCount) {
    return money.substr(0, money.length - 3);
  }

  return money;
}

export function phoneFormatter(number) {
  let cleanNumber = (number || '').replace(/[^0-9]/g, '');
  let firstNumberIsOne = cleanNumber.charAt(0) === '1';

  if (firstNumberIsOne) {
    cleanNumber = cleanNumber.substr(1);
    firstNumberIsOne = false;
  }

  if (cleanNumber.length === 10 && !firstNumberIsOne) {
    const areaCode = cleanNumber.substr(0, 3);
    const prefix = cleanNumber.substr(3, 3);
    const line = cleanNumber.substr(6, 4);
    number = `${areaCode}-${prefix}-${line}`;
  }

  return number;
}

export function bytesToSize(bytes) {
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

export const formatCurrency = (amount, currency = null) => {
  currency = currency || localStorage.getItem("STORE_CURRENCY");

  if (!currency) {
    currency = UserCountry() === 'NG' ? 'NGN' : 'USD';
  } else {
    currency = currency.toUpperCase() === 'NG' ? 'NGN' : 'USD';
  }

  const locale = currency === 'NGN' ? 'en-NG' : 'en-US';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
};
